const SpinIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 24" className="tw-w-full">
    <path
      d="M24 11c0-3.15-5.17-5.5-12-5.5S0 7.85 0 11c0 1.82 1.67 3.39 4.7 4.41a1 1 0 0 0 1.3-.6c0-.06 0-.15.06-.21a1 1 0 0 0-.68-1C3.37 12.85 2 11.84 2 11c0-1.48 3.81-3.54 10-3.54s9.9 2.06 9.9 3.54c0 1.08-1.89 2.32-5 3l1.58-1.31a1 1 0 0 0 .09-1.4 1.07 1.07 0 0 0-1.45-.09l-4.33 3.6a.94.94 0 0 0-.31.45.74.74 0 0 0 0 .44 1 1 0 0 0 .65.75l5.32 2a.82.82 0 0 0 .37.06 1 1 0 0 0 1-.62 1 1 0 0 0-.59-1.28l-1.82-.69C21.43 15 24 13.2 24 11"
      fillRule="evenodd"
      fill="currentColor"
    />
  </svg>
);

export default SpinIcon;
